import { useAuth } from '../contexts/AuthContext';
import { useCachedFlowCompletionStatus } from './useCachedFlowCompletionStatus';

/**
 * A custom hook that combines authentication state with intake assessment completion status
 * @returns Combined auth and intake status information
 */
export const useAuthWithIntakeStatus = () => {
  const { isAuthenticated, user, login, logout, updateUser, isAuthLoading } = useAuth();
  const { 
    completionStatus: intakeCompletionStatus, 
    loading: intakeStatusLoading, 
    error: intakeStatusError,
    refetch: refetchIntakeStatus
  } = useCachedFlowCompletionStatus('intake_assessment_v0', true); // Use fallback to user data

  // If we have an error and user data is available, use that as fallback
  const hasCompletedIntake = !!intakeCompletionStatus?.completed_at || 
                            (intakeStatusError && user?.has_completed_intake === true);

  return {
    // Auth state
    isAuthenticated,
    user,
    isAuthLoading,
    login,
    logout,
    updateUser,
    
    // Intake status
    hasCompletedIntake,
    intakeCompletedAt: intakeCompletionStatus?.completed_at || null,
    intakeStatusLoading,
    intakeStatusError,
    refetchIntakeStatus
  };
};

export default useAuthWithIntakeStatus;
